import React from 'react'

import {isNil, noop} from 'es-toolkit'

import useUniqueId from '../../hooks/use-unique-id'
import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

type Props = Overwrite<
  CommonProps<'label'>,
  {
    label: React.ReactNode
    name?: string
    checked?: boolean
    emphasized?: boolean
    value?: string
    onChange?: React.ChangeEventHandler<HTMLInputElement>
    disabled?: boolean
    id?: string
    count?: React.ReactNode
  }
>

const RadioGroupItem = ({
  className,
  id,
  name,
  label,
  checked = false,
  emphasized = false,
  onChange = noop,
  disabled = false,
  value = '',
  count,
  ...props
}: Props) => {
  const actualId = useUniqueId(id)

  return (
    <label
      {...props}
      htmlFor={actualId}
      className={cn('RadioGroupItem', {checked, emphasized}, className)}
      aria-checked={checked}
      aria-disabled={disabled}
    >
      <input
        id={actualId}
        className="RadioGroupItem__input"
        type="radio"
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
      />
      <div className="RadioGroupItem__label">{label}</div>
      {!isNil(count) && <div className="RadioGroupItem__count">({count})</div>}
    </label>
  )
}

export default RadioGroupItem
